import React, { useEffect, useState } from 'react'
import Header from '../layout/Header'
import { careProviders } from '../../actions/application/careProviders'
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import Swal from 'sweetalert2';
import { assignApplication, resetAssignApplication } from '../../actions/application/assignApplications';
import { getApplication, resetGetApplication } from '../../actions/application/getApplication';
import { use } from 'i18next';
import { updateApplicationStatus } from '../../actions/application/updateApplicationStatus';
import { getDoctorCv, resetDoctorCv } from '../../actions/application/getDoctorCv';
import { Link } from 'react-router-dom';

function SelectDoctor(props) {
    const { Id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [careProviderId, setCareProviderId] = useState("")
    const [professionId, setProfessionId] = useState("")
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        dispatch(getApplication(Id))
        dispatch(resetDoctorCv());
    }, [dispatch])

    function handleAssignment(e) {
        e.preventDefault();
        let carePId = careProviderId
        dispatch(assignApplication(Id, carePId, 0))
        setMounted(true)
    }


    useEffect(() => {

        if (props.getApplication.done) {
            setProfessionId(props.getApplication.getApplication.patientCurrentOther)
        }


    }, [props.getApplication])
    useEffect(() => {
        if (props.careProviders.error !== false) {
            Swal.fire({
                icon: 'error',
                title: 'Hata',
                confirmButtonText: "Anladım",
                confirmButtonColor: "#09c35c",
                text: "Sistem bir hata ile karşılaştı. Lütfen daha sonra tekrar deneyiniz.",
                footer: '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>'
            })
        }
    }, [props.careProviders])


    useEffect(() => {
        if (professionId) {
            dispatch(careProviders(professionId))
        }
    }, [dispatch, professionId])


    useEffect(() => {
        if (mounted && props.assignApplication.done === true) {
            navigate("/payment/" + Id)
            setMounted(false)
            dispatch(updateApplicationStatus(Id, 2))
            dispatch(resetAssignApplication())
            dispatch(resetGetApplication())
        }
        if (props.assignApplication.error !== false) {
            Swal.fire({
                icon: 'error',
                title: 'Hata',
                confirmButtonText: "Anladım",
                confirmButtonColor: "#09c35c",
                text: "Sistem bir hata ile karşılaştı. Lütfen daha sonra tekrar deneyiniz.",
                footer: '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>'
            })
        }
    }, [props.assignApplication])


    return (
        <div>
            <Header />
            <div className='pt-10 md:ml-64 ps-5'>
                <ol className="flex items-center whitespace-nowrap min-w-0" aria-label="Breadcrumb">
                    <li className="text-sm">
                        <a
                            className="flex items-center text-gray-500 hover:text-dark-600" href="#">
                            Yeni Başvuru
                            <svg className="flex-shrink-0 mx-3 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                            </svg>
                        </a>
                    </li>
                    <li className="text-sm">
                        <a
                            className="flex items-center text-gray-500 hover:text-dark-600" href="#">
                            Talep Formu
                            <svg className="flex-shrink-0 mx-3 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                            </svg>
                        </a>
                    </li>
                    <li className="text-sm">
                        <Link
                            to={"/file-upload/" + Id}
                            className="flex items-center text-gray-500 hover:text-dark-600" href="#">
                            Dosya Yükleme
                            <svg className="flex-shrink-0 mx-3 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                            </svg>
                        </Link>
                    </li>
                    <li className="text-sm font-semibold text-gray-800 truncate dark:text-gray-200" aria-current="page">
                        Hekim Belirle
                    </li>
                </ol>
            </div>
            <hr className='divide-y mt-2' />
            <h1 className='text-2xl font-semibold text-start mt-5 ps-5 md:ml-64'>Hekim Belirle</h1>
            {props.careProviders.done ?
                <div className='mt-5 ps-5 pe-5 md:ml-64 text-start'>
                    <label for="hs-select-label" class="block text-sm font-medium mb-2 dark:text-white text-start">Lütfen Hekiminizi Seçiniz</label>
                    <select
                        onChange={(e) => {
                            setCareProviderId(e.target.value)
                            localStorage.setItem("careProviderId", e.target.value)
                            dispatch(getDoctorCv(e.target.value))
                        }}
                        id="hs-select-label" class="py-3 px-4 pr-9 mb-3  w-full border-gray-200 rounded-md text-sm focus:border-green-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400">
                        <option selected>Lütfen Seçiniz</option>
                        {
                            props.careProviders.careProviders.result.data
                                .sort((a, b) => a.fullName.localeCompare(b.fullName)) // Alfabetik sıralama yapılıyor
                                .map((element, index) =>
                                    <option key={index} name={element.fullName} value={element.careProviderId}>{element.title + " " + element.fullName}</option>
                                )
                        }
                    </select>
                    <a
                        href='https://www.hastane.başkent.edu.tr/1142.html'
                        style={{ color: `#09C35C`, textAlign: "left" }}
                        target='_blank'
                    >
                        <u>
                            Doktor özgeçmişlerini buradan görüntüleyebilirsiniz.
                        </u>
                    </a>
                </div>
                :
                props.careProviders.spinner ?
                    <div class="relative mt-5 ps-5 pe-5 md:ml-64">
                        <div class="bg-yellow-50 border border-red-200 rounded-md p-4">
                            <div class="flex">

                                <div class="ml-3 text-start">
                                    <h3 class="text-sm text-red-800 font-medium">
                                        Hekim bilgileri yükleniyor
                                    </h3>
                                    <div class="text-sm text-red-700 mt-2">
                                        <span class="font-semibold">Lütfen bekleyin!</span> Hekimler ilgili kaynaktan çekiliyor.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="absolute top-0 left-0 w-full h-full bg-white/[.5] rounded-md dark:bg-gray-800/[.4]"></div>
                        <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                            <div class="animate-spin inline-block w-6 h-6 border-[3px] border-current border-t-transparent text-red-600 rounded-full" role="status" aria-label="loading">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    : null

            }
            <div className='md:ml-64 ps-5 mt-5 pe-5'>
                <button
                    onClick={handleAssignment}
                    style={{ backgroundColor: `#09C35C` }}
                    type="button"
                    class="mb-10 w-full py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800 mt-5">
                    Devam et
                </button>
            </div>

            {/* <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="card mt-4">
                            <div className="card-body">
                                {props.careProviders.done ?
                                    <div id='subject'>
                                        <label htmlFor="question_4" className='form-label mt-5 d-flex justify-content-start align-items-start mb-4'>Görüşünü Almak İstediğiniz Hekim</label>
                                        <select
                                            onChange={(e) => {
                                                setCareProviderId(e.target.value)
                                                localStorage.setItem("careProviderId", e.target.value)
                                                dispatch(getDoctorCv(e.target.value))
                                            }}
                                            name='doctor'
                                            id='question_4'
                                            className="form-select"
                                            aria-label="Select example"
                                        >
                                            <option value="seçilmedi">Seçiniz</option>
                                            {
                                                props.careProviders.careProviders.result.data
                                                    .sort((a, b) => a.fullName.localeCompare(b.fullName)) // Alfabetik sıralama yapılıyor
                                                    .map((element, index) =>
                                                        <option key={index} name={element.fullName} value={element.careProviderId}>{element.title + " " + element.fullName}</option>
                                                    )
                                            }


                                        </select>


                                    </div>
                                    :
                                    <div className="card mt-3 mb-4">
                                        <div className="card-body">
                                            <div className="text-center">
                                                <div className="spinner-border" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="d-grid gap-2 mt-4">
                                    <button onClick={handleAssignment} className='btn btn-outline-primary'>Devam et</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-12' style={props.getDoctorCv.done ? { display: `` } : { display: `none` }}>
                        <div className="card mt-4">
                            <div className="card-body">
                                <div class="ratio ratio-16x9">
                                    <iframe src={props.getDoctorCv.done ? props.getDoctorCv.careProviders.DoctorFileUrl : null} title="YouTube video" allowfullscreen></iframe>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </div>
    )
}

const mapStateToProps = (state) => {
    return state;
};
const mapDispatchToProps = {
};
export default connect(mapStateToProps, mapDispatchToProps)(SelectDoctor);